import {AutorunComponent} from '@myshared/autorun.component';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderState} from "../../buy/buy.model";
import { Model } from 'src/app/app.model';

@Component({
    selector: 'order-list',
    templateUrl: './order-list.component.html',
    standalone: false
})
export class OrderListComponent extends AutorunComponent implements OnInit {
    public state: OrderState;
    public selectedView: 'drafts' | 'invoices' | 'orders' = 'drafts';
    public isAdmin: boolean;

    constructor(private activatedRoute: ActivatedRoute, private m: Model, private router: Router) {
        super();
    }

    ngOnInit(): void {
        this.autorun(() => {
            this.isAdmin = this.m.account.isMypascomAdmin;
        });
        this.activatedRoute.paramMap.subscribe(r => {
            const subroute = r.get('subroute');
            if (!this.isAdmin && subroute !== 'invoices') {
                this.router.navigate(['/orders', 'invoices']);
                return;
            }
            
            if (subroute === 'invoices') {
                this.selectedView = 'invoices';
                this.state = null;
            } else if (subroute === 'drafts') {
                this.selectedView = 'drafts';
                this.state = null;
            } else {
                this.selectedView = 'orders';
                this.state = subroute === 'orders' ? 'sale' : 'sent';
            }
        });
    }

    public get isInvoices() { return this.selectedView === 'invoices'; }
    public get isDrafts() { return this.selectedView === 'drafts'; }
    public get isOrders() { return this.selectedView === 'orders'; }
}
